import { selectDictNoticeType } from '@src/modules/dictionaries/store'
import { Combobox } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'

export class NotificationKindColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.NOTIFICATION_KIND

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Вид извещения',
        component: Combobox,
        props: {
          allowClear: true,
          options: selectDictNoticeType(store.getState()).payload?.map(mo => ({
            label: mo.name,
            value: mo.row_code,
            title: mo.name,
          })),
        },
      },
      width: 200,
      dataIndex: 'notification_kind',
      dataRender: notification_kind => notification_kind ? notification_kind : '-',
      sort: true,
      nullSearch: true,
    }

    super(column, settings)
  }

  _requestArgs ({ filters, nullSearches }) {
    let requestFilters = []

    if (filters?.notification_kind) {
      requestFilters = [{ field: 'notification_kind_code', value: filters?.notification_kind, operator: 'like_both', invalid: false }]
    }

    if (nullSearches.notification_kind) {
      requestFilters = [{ field: 'notification_kind_code', value: null, operator: '=', invalid: false }]
    }

    return {
      control: {
        filters: requestFilters,
      },
    }
  }
}
